import React, { useState } from "react";
import foto from "../images/Multitessere/MultitesseraCard.png";
import { useNavigate } from "react-router-dom";
import "../styles/CardMultitessere.css";

import { motion } from 'framer-motion';

function CardMultitessere() {
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <div
            className="card-multitessere d-flex flex-row align-self-center"
            onClick={() => navigate("/multitessere")}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{
                marginTop: "1em",
                transition: "transform 0.5s" // Aggiunta di una transizione per un effetto più fluido
            }}
        >
            <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} >
            <img
                src={foto}
                alt="Immagine"
                style={{
                    width: "100%",
                    border: "solid",
                    borderRadius: "1em",
                    overflow: "hidden",
                    transform: isHovered ? "scale(1.15)" : "scale(1)" // Modifica della scala al passaggio del mouse
                }}
            />
            <div className="card-multitessere-text"></div>
                </motion.div>
        </div>
    );
}

export default CardMultitessere;
